import TrainingAttachment from '../attachment';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingAttachment.destroy(({ trainingId, attachmentId }, fetch) => {
    return fetch.delete(`/trainings/${trainingId}/attachments/${attachmentId}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };